import { Box, Card, CardContent, CardHeader, Divider, Grid, Typography } from "@mui/material"
import CustomSkeleton from "../../../../components/common/CustomSkeleton"
import useGiftCreditActiveRequests from "../../../dashboard/gift-credit/hooks/useGiftCreditActiveRequests"
import CreditListItem from "./credit-box/CreditListItem"

const GiftCreditsHistory = ({ height }) => {
  const { data, isFetching, isPending } = useGiftCreditActiveRequests()
  return (
    <CustomSkeleton isLoading={isFetching}>
      <Card variant='outlined' sx={{ borderRadius: 2 }}>
        <CardHeader title='لیست اعتبارات ' />
        <CardContent sx={{ p: 1, minHeight: height }}>
          <Divider />
          <Grid container spacing={1}>
            {!isPending && data?.value?.length === 0 && (
              <Box display='flex' justifyContent='center' mt={1} p={2} width='100%'>
                <Typography variant='caption'>رکوردی برای نمایش یافت نشد!</Typography>
              </Box>
            )}
            {data?.value?.map((credit, index) => (
              <CreditListItem key={index} credit={credit} />
            ))}
          </Grid>
        </CardContent>
      </Card>
    </CustomSkeleton>
  )
}

export default GiftCreditsHistory
